import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import {
  checkDeleteFNCPendingAccount,
  deleteFNCPendingAccount,
} from 'lib/api/fnc';
import CustomButton from 'lib/designSystem/Button';
import { showAlert } from 'lib/functions/utils';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

interface DeleteFNCPendingAccountDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  FNCId: number;
  FNCPendingAccountId: number;
  handleDetails: (id: number, setUp?: boolean) => void;
}

const DeleteFNCPendingAccountDialog = (
  props: DeleteFNCPendingAccountDialogProps,
) => {
  const { open, setOpen, FNCId, FNCPendingAccountId, handleDetails } = props;
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [canDelete, setCanDelete] = useState(false);
  const [reason, setReason] = useState('');

  const setUp = async () => {
    setLoading(true);
    try {
      const response = await checkDeleteFNCPendingAccount(
        dispatch,
        FNCId,
        FNCPendingAccountId,
      );
      setCanDelete(response.canDelete);
      setReason(response.reason);
    } catch (error) {
      showAlert(
        dispatch,
        'error',
        'Error al evaluar si se puede eliminar la CxP pendiente',
      );
    }
    setLoading(false);
  };

  const handleDelete = async () => {
    setLoading(true);
    try {
      await deleteFNCPendingAccount(dispatch, FNCId, FNCPendingAccountId);
      showAlert(dispatch, 'success', 'CxP pendiente eliminada correctamente');
      void handleDetails(FNCId, true);
      setOpen(false);
    } catch (error) {
      showAlert(dispatch, 'error', 'Error al reversar el FNC');
    }
    setLoading(false);
  };

  useEffect(() => {
    if (FNCId && FNCPendingAccountId) {
      void setUp();
    }
  }, [FNCId, FNCPendingAccountId]);

  return (
    <Dialog open={open}>
      <DialogTitle>
        Eliminar CxP pendiente folio: {FNCPendingAccountId}
      </DialogTitle>
      <DialogContent>
        <Typography>
          ¿Estás seguro de querer eliminar esta CxP pendiente?
        </Typography>
        {reason && (
          <Typography color="error" sx={{ mt: 1 }}>
            {reason}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <CustomButton
          onClick={() => setOpen(false)}
          disabled={loading}
          color="secondary"
        >
          Cancelar
        </CustomButton>
        <CustomButton
          onClick={handleDelete}
          disabled={loading || !canDelete}
          color="error"
        >
          Eliminar
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteFNCPendingAccountDialog;
